export class LogoController {
  constructor() {
    this._logoDisplayed = false;
    this._redirectUrl = "https://polygonjs.com";
  }
  display(options) {
    this._logoDisplayed = true;
    this._datauri = options.datauri;
    this._redirectUrl = options.redirectUrl;
  }
  displayed() {
    return this._logoDisplayed;
  }
  datauri() {
    return this._datauri;
  }
  redirectUrl() {
    return this._redirectUrl;
  }
}
